import * as React from "react";
const SvgFiRrWindsock = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-windsock_svg__a)">
      <path
        fill="#062147"
        d="M3 24a1 1 0 0 1-1-1V5.829A3.007 3.007 0 0 1 3 0a3.014 3.014 0 0 1 1.86 5.352L21.59 8.7A3.01 3.01 0 0 1 24 11.64v1.72a3.01 3.01 0 0 1-2.413 2.94L4 19.82V23a1 1 0 0 1-1 1M4 7.22v10.56l2-.4V7.62zm4 .8v8.96l2-.4V8.42zm4 .8v7.36l2-.4V9.22zm4 .8v5.76l2-.4v-4.96zm4 .8v4.162l1.2-.24a1 1 0 0 0 .8-.981V11.64a1 1 0 0 0-.8-.981zM3 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-windsock_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWindsock;
